export const ADD_TO_ENTITIES = 'ADD_TO_ENTITIES';
export const CLEAN_ALL_ENTITIES = 'CLEAN_ALL_ENTITIES';
export const CLEAN_ONE_ENTITY = 'CLEAN_ONE_ENTITY';
export const SEARCH = 'SEARCH';
export const STOP_AUTHENTICATED_SAGAS = 'STOP_AUTHENTICATED_SAGAS';
